var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14645 14.6464C9.34172 14.4512 9.6583 14.4512 9.85356 14.6465L12 16.793V4C12 3.72386 12.2239 3.5 12.5 3.5C12.7761 3.5 13 3.72386 13 4V16.7928L15.1465 14.6464C15.3417 14.4512 15.6583 14.4512 15.8536 14.6465C16.0488 14.8417 16.0488 15.1583 15.8535 15.3536L12.8603 18.3466C12.7694 18.4412 12.6416 18.5 12.5 18.5C12.4515 18.5 12.4046 18.4931 12.3603 18.4802C12.282 18.4575 12.2081 18.4153 12.1463 18.3535L9.14644 15.3535C8.95118 15.1583 8.95119 14.8417 9.14645 14.6464Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51351 12.5C3.79712 12.5 4.02703 12.7411 4.02703 13.0385V21.4231H20.973V13.0385C20.973 12.7411 21.2029 12.5 21.4865 12.5C21.7701 12.5 22 12.7411 22 13.0385V21.9615C22 22.2589 21.7701 22.5 21.4865 22.5H3.51351C3.22991 22.5 3 22.2589 3 21.9615V13.0385C3 12.7411 3.22991 12.5 3.51351 12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.6e97f1edf6cb048e009465a12dce2f60.svg";
export { ForwardRef as ReactComponent };